import {FC, useCallback} from "react";
import {RatingsIcon} from "../../../icons/projectToolsWithResize/RatingsIcon";
import {useTranslation} from "react-i18next";
import { HintTooltip } from "@brg/ui";
import {IconWrapperSpecial2} from "../../../assets/styles";
import {ProjectCompetitionsWrapper, ToolBarItemWrapperModer} from "./ProjectCompetitions";
import {Link} from "react-router-dom";
import styled, {css, useTheme} from "styled-components";
import {LayoutConst} from "../../../../core";
import {AppTester} from "../../../../supporting";
import { getTooltipStyles } from "shared/constants/tooptipStyles";

interface ProjectRatingsButton {
    isBottomTooltip?: boolean
    projectId?: string
    onWhiteBg?: boolean
    tooltipProps?: any
}

export const RatingsWrapper = styled(ProjectCompetitionsWrapper)`
    margin-right: ${({isBottomTooltip}) => isBottomTooltip ? 32 : 0}px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-right: 0;
  }
`

const RatingIconWrapperSpecial2 = styled(IconWrapperSpecial2)<{isBottomTooltip?: boolean}>`
    
    ${({isBottomTooltip}) => isBottomTooltip && css`
      svg {
        rect {
          stroke: rgba(0,0,0,0.47) !important
        }
    `}
`

export const ProjectRatingsButton: FC<ProjectRatingsButton> = ({isBottomTooltip, onWhiteBg, projectId, tooltipProps}) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const superPuperStyles = {...getTooltipStyles(theme), background: "#464645", backgroundColor: "#464645"}

    return <Link to={`/ratings/${projectId}`}><RatingsWrapper isBottomTooltip={isBottomTooltip}><ToolBarItemWrapperModer className="RatingButtonWrapper ps-action-moder-btn">
        <RatingIconWrapperSpecial2 isBottomTooltip={isBottomTooltip} onClick={() => {}}>
            <HintTooltip customStyle={superPuperStyles} text={t("hints.ratings")} z={8} onWhiteBg={onWhiteBg} noDisappearDelay={isBottomTooltip} {...tooltipProps}>
                <RatingsIcon/>
            </HintTooltip>
        </RatingIconWrapperSpecial2>
    </ToolBarItemWrapperModer></RatingsWrapper></Link>
}import {FC, useCallback} from "react";
import {RatingsIcon} from "../../../icons/projectToolsWithResize/RatingsIcon";
import {useTranslation} from "react-i18next";
import { HintTooltip } from "@brg/ui";
import {IconWrapperSpecial2} from "../../../assets/styles";
import {ProjectCompetitionsWrapper, ToolBarItemWrapperModer} from "./ProjectCompetitions";
import {Link} from "react-router-dom";
import styled, {css, useTheme} from "styled-components";
import {LayoutConst} from "../../../../core";
import {AppTester} from "../../../../supporting";
import { getTooltipStyles } from "shared/constants/tooptipStyles";

interface ProjectRatingsButton {
    isBottomTooltip?: boolean
    projectId?: string
    onWhiteBg?: boolean
    tooltipProps?: any
}

export const RatingsWrapper = styled(ProjectCompetitionsWrapper)`
    margin-right: ${({isBottomTooltip}) => isBottomTooltip ? 32 : 0}px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-right: 0;
  }
`

const RatingIconWrapperSpecial2 = styled(IconWrapperSpecial2)<{isBottomTooltip?: boolean}>`
    
    ${({isBottomTooltip}) => isBottomTooltip && css`
      svg {
        rect {
          stroke: rgba(0,0,0,0.47) !important
        }
    `}
`

export const ProjectRatingsButton: FC<ProjectRatingsButton> = ({isBottomTooltip, onWhiteBg, projectId, tooltipProps}) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const superPuperStyles = {...getTooltipStyles(theme), background: "#464645", backgroundColor: "#464645"}

    return <Link to={`/ratings/${projectId}`}><RatingsWrapper isBottomTooltip={isBottomTooltip}><ToolBarItemWrapperModer className="RatingButtonWrapper ps-action-moder-btn">
        <RatingIconWrapperSpecial2 isBottomTooltip={isBottomTooltip} onClick={() => {}}>
            <HintTooltip customStyle={superPuperStyles} text={t("hints.ratings")} z={8} onWhiteBg={onWhiteBg} noDisappearDelay={isBottomTooltip} {...tooltipProps}>
                <RatingsIcon/>
            </HintTooltip>
        </RatingIconWrapperSpecial2>
    </ToolBarItemWrapperModer></RatingsWrapper></Link>
}